import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable, OnDestroy } from "@angular/core";

import { environment } from "src/environments/environment";

import { AppSettings } from "src/components/shared-components/class/general-classes/app-settings";

import { LoggerService } from "./logger.service";

import {
  AddressFunction,
  AddressFunctionCategory,
} from "src/components/shared-components/class/component-classes/address-function";
@Injectable({
  providedIn: "root",
})
export class AddressFunctionService implements OnDestroy {
  private _logContext: string = "Address-function.service";

  private _isErrorInGetAddressListAPIRequest: boolean = false;

  constructor(
    private _http: HttpClient,
    private _loggerService: LoggerService
  ) {}

  ngOnDestroy() {}

  /**
   * Get address functions category
   *
   * @returns
   */
  public getAddressFunctionCategory(): Promise<Array<AddressFunctionCategory>> {
    return this._http
      .get<Array<AddressFunctionCategory>>(
        environment.httpServerRoot +
          AppSettings.API_URL_ADDRESS_FUNCTION +
          "/category"
      )
      .toPromise();
  }

  /**
   * Get address functions category
   *
   * @returns
   */
  public getAddressFunction(): Promise<Array<AddressFunction>> {
    return this._http
      .get<Array<AddressFunction>>(
        environment.httpServerRoot + AppSettings.API_URL_ADDRESS_FUNCTION
      )
      .toPromise();
  }
}
